import { useIntl } from '@metsooutotec/modes-react-components';
import { Customer } from '../models/customer-models';
import { Site } from 'features/organizations/sites/models/sites-models';
import { Asset } from 'features/organizations/assets/models/asset-models';
import { AssetSection } from 'features/organizations/asset-sections/models/asset-section-models';

export const GenerateBreadcrumbs = (
    customer: Customer | undefined,
    site: Site | undefined,
    asset: Asset | undefined,
    assetSection: AssetSection | undefined,
): { text: string; to: string }[] => {
    const { formatMessage } = useIntl();
    const breadcrumbs: { text: string; to: string }[] = [
        {
            text: formatMessage('customerList.title'),
            to: '/customers',
        },
    ];

    if (customer) {
        breadcrumbs.push({
            text: customer.name,
            to: `/customers/${customer.id}`,
        });

        if (site) {
            breadcrumbs.push({
                text: site.name,
                to: `/customers/${customer.id}/sites/${site.id}`,
            });

            if (asset) {
                breadcrumbs.push({
                    text: asset.name,
                    to: `/customers/${customer.id}/sites/${site.id}/assets/${asset.id}`,
                });

                if (assetSection) {
                    breadcrumbs.push({
                        text: assetSection.name,
                        to: `/customers/${customer.id}/sites/${site.id}/assets/${asset.id}/assetsections/${assetSection.id}`,
                    });
                }
            }
        }
    }

    return breadcrumbs;
};